<template>
  <el-dialog
    :title="detailTitle"
    :visible.sync="CUFlag"
    v-if="CUFlag"
    :close-on-click-modal="false"
  >
    <el-form
      :model="ruleForm"
      ref="rForm"
      label-width="100px"
      class="ruleForm"
      ::rules="rules"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="审核结果："
            prop="auditSchedule"
            :rules="[{ required: true, message: '请选择审核意见' }]"
          >
            <el-radio-group
              v-model="ruleForm.auditSchedule"
              @change="auditScheduleChange"
            >
              <el-radio
                v-for="(item, i) in auditScheduleAttr"
                :key="i"
                :label="item.paramKey"
              >
                {{ item.paramValue }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="驳回原因："
            prop="auditContent"
            v-if="ruleForm.auditSchedule == 1"
            :rules="[{ required: true, message: '请输入驳回原因' }]"
          >
            <el-input
              type="textarea"
              placeholder="请输入驳回原因"
              autosize
              v-model="ruleForm.auditContent"
              @input="reasonInputEvent"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="短信通知："
            prop="isNotice"
            :rules="[{ required: true, message: '请选择短信通知' }]"
          >
            <el-radio-group
              v-model="ruleForm.isNotice"
              @change="isNoticeChange"
            >
              <el-radio
                v-for="(item, i) in isNoticeAttr"
                :key="i"
                :label="item.paramKey"
              >
                {{ item.paramValue }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <div v-if="isSend">
        <el-row>
          <el-col>
            <el-form-item label="消息内容：" prop="sendMessage">
              <el-input
                v-model="ruleForm.sendMessage"
                :disabled="true"
                type="textarea"
                autosize
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item
              label="发送对象："
              prop="sendPerson"
              :rules="[{ required: true, message: '请选择发送对象' }]"
            >
              <div>{{ruleForm.sendPerson}}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <!--<el-row>
          <el-col>
            <el-form-item
              label="发送方式："
              prop="noticeType"
              :rules="[{ required: true, message: '请选择发送方式' }]"
            >
              <el-radio-group v-model="ruleForm.noticeType">
                <el-radio
                  v-for="(item, i) in noticeTypeAttr"
                  :key="i"
                  :label="item.paramKey"
                >
                  {{ item.paramValue }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row> -->
      </div>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom()" btntype title="取消"></butn>
      <butn
        btntype="primary"
        @click.native="updateForm()"
        title="确定"
        v-permission="'audit:enroll:updateBatch'"
      ></butn>
    </div>
  </el-dialog>
</template>
<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
import { updateBatchAuditNew } from "@/api/enrollment";

export default {
  components: { butn },
  data() {
    return {
      size: "small",
      ruleForm: {
        auditSchedule: "2",
        auditContent: "",
        sendMessage: "",
        isNotice: true,
        sendPerson: ''
      },
      detailTitle: "报名审核",
      CUFlag: false,
      isSend: true,
      auditScheduleAttr: [],
      isNoticeAttr: [
        { paramValue: "否", paramKey: false },
        { paramValue: "是", paramKey: true }
      ],
      rules: [],
      thisItem: {},
      batchType: 0,

      oneAgreeMsg: '您好，您给{学员姓名}报名参加的{班级名称}，审核已通过。',
      oneRefuseMsg: '您好，您给{学员姓名}报名参加的{班级名称}，审核未通过，原因：{驳回原因}。如有疑问，请联系主办单位。',
      batchAgressMsg: '您好，您给{学员姓名}等x人报名参加的{班级名称}，审核已通过。',
      batchRefuseMsg: '您好，您给{学员姓名}等x人报名参加的{班级名称}，审核未通过，原因：{驳回原因}。如有疑问，请联系主办单位。',
      sendTypeMsg: ''
    };
  },
  methods: {
    auditScheduleChange() {
      let text = '';
      if (this.batchType == 1) {
        if (this.ruleForm.auditSchedule === "2") {
          text = this.batchAgressMsg;
        } else if (this.ruleForm.auditSchedule === "1") {
          text = this.batchRefuseMsg;
        }
      } else {
        if (this.ruleForm.auditSchedule === "2") {
          text = this.oneAgreeMsg;
        } else {
          text = this.oneRefuseMsg;
        } 
      }
      this.sendTypeMsg = text;
      this.ruleForm.sendMessage = text;
      this.ruleForm.sendMessage = this.dealAuditContent(this.ruleForm.auditContent);
    },
    dealAuditContent(text) {
      if (text && text.length > 0) {
        return this.sendTypeMsg.replace("{驳回原因}",text);
      } else {
        return this.sendTypeMsg.replace("，原因：{驳回原因}", '');
      }
    },
    reasonInputEvent(val) {
      this.ruleForm.sendMessage = this.dealAuditContent(val)
    },
    isNoticeChange() {
      if (this.ruleForm.isNotice) {
        this.isSend = true;
      } else {
        this.isSend = false;
        this.ruleForm.sendMessage = "";
      }
      this.auditScheduleChange();
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        this.auditScheduleAttr = res.data["AUDIT_SCHEDULE"].slice(1, 3);
      });
    },
    // 关闭
    closeFrom() {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.isNotice = true;
      this.isSend = true;
      this.$refs["rForm"].resetFields();
    },
    // 确定
    updateForm() {
      this.$refs["rForm"].validate(valid => {
        if (valid) {
          let params = {};
          let auditUserList = [];
          if (this.batchType == 0) {
            auditUserList = [this.thisItem].map(ele => ({
              // auditDeptId: ele.auditDeptId,
              auditApplyId: ele.uuid,
              sendPerson: ele.createUserId
            }));
          } else {
            // 发送对象sendPerson：暂时只有一个
            auditUserList = this.thisItem.map(ele => ({
              // auditDeptId: ele.auditDeptId,
              auditApplyId: ele.uuid,
              sendPerson:  ele.createUserId
            }));
          }
          params = Object.assign({}, this.ruleForm);
          delete params.sendPerson;
          params.classAuditHistoryVoList = auditUserList;
          updateBatchAuditNew(params).then(res => {
            if (res.code === 0) {
              this.$message.success(res.msg);
              this.$emit("refreshTable");
            }
          });
          this.closeFrom();
        }
      });
    },
    show(item, batch) {
      this.CUFlag = true;
      this.ruleForm = {
        auditSchedule: "2",
        auditContent: "",
        sendMessage: "",
        isNotice: true,
        sendPerson: ''
      }
      // 是否轮训班
      this.ruleForm.isRotationClass = false;
      this.batchType = batch;
      this.thisItem = item;

      this.oneAgreeMsg = '您好，您给{学员姓名}报名参加的{班级名称}，审核已通过。'
      this.oneRefuseMsg = '您好，您给{学员姓名}报名参加的{班级名称}，审核未通过，原因：{驳回原因}。如有疑问，请联系主办单位。'

      if (this.batchType == 0) {
        this.ruleForm.sendPerson = item.createUserName;
        this.oneAgreeMsg = this.oneAgreeMsg.replace("{学员姓名}", item.userName).replace("{班级名称}", item.className)
        this.oneRefuseMsg = this.oneRefuseMsg.replace("{学员姓名}", item.userName).replace("{班级名称}", item.className)
        this.ruleForm.sendMessage = this.oneAgreeMsg;
        this.sendTypeMsg = this.oneAgreeMsg;
      } else {
        this.ruleForm.sendPerson = '所有单位联络员';
        this.ruleForm.sendMessage = this.batchAgressMsg;
        this.sendTypeMsg = this.batchAgressMsg;
      }
    },
  },
  created() {
    this.getSysParamByTypes(["AUDIT_SCHEDULE"]);
  }
};
</script>
